/*
 * International Telephone Input v12.1.2
 * https://github.com/jackocnr/intl-tel-input.git
 * Licensed under the MIT license
 */
! function (a) {
    "function" == typeof define && define.amd ? define(["jquery"], function (b) {
        a(b, window, document)
    }) : "object" == typeof module && module.exports ? module.exports = a(require("jquery"), window, document) : a(jQuery, window, document)
}(function (a, b, c, d) {
    "use strict";

    function e(b, c) {
        this.a = a(b), this.b = a.extend({}, h, c), this.ns = "." + f + g++, this.d = Boolean(b.setSelectionRange), this.e = Boolean(a(b).attr("placeholder"))
    }
    var f = "intlTelInput",
        g = 1,
        h = {
            allowDropdown: !0,
            autoHideDialCode: !0,
            autoPlaceholder: "polite",
            customPlaceholder: null,
            dropdownContainer: "",
            excludeCountries: [],
            formatOnDisplay: !0,
            geoIpLookup: null,
            hiddenInput: "",
            initialCountry: "",
            nationalMode: !0,
            onlyCountries: [],
            placeholderNumberType: "MOBILE",
            preferredCountries: ["us", "gb", "in"],
            separateDialCode: !1,
            utilsScript: ""
        },
        i = {
            b: 38,
            c: 40,
            d: 13,
            e: 27,
            f: 43,
            A: 65,
            Z: 90,
            j: 32,
            k: 9
        },
        j = ["800", "822", "833", "844", "855", "866", "877", "880", "881", "882", "883", "884", "885", "886", "887", "888", "889"];
    a(b).on("load", function () {
        a.fn[f].windowLoaded = !0
    }), e.prototype = {
        _a: function () {
            return this.b.nationalMode && (this.b.autoHideDialCode = !1), this.b.separateDialCode && (this.b.autoHideDialCode = this.b.nationalMode = !1), this.g = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), this.g && (a("body").addClass("iti-mobile"), this.b.dropdownContainer || (this.b.dropdownContainer = "body")), this.h = new a.Deferred, this.i = new a.Deferred, this.s = {}, this._b(), this._f(), this._h(), this._i(), this._i2(), [this.h, this.i]
        },
        _b: function () {
            this._d(), this._d2(), this._e()
        },
        _c: function (a, b, c) {
            b in this.q || (this.q[b] = []);
            var d = c || 0;
            this.q[b][d] = a
        },
        _d: function () {
            if (this.b.onlyCountries.length) {
                var a = this.b.onlyCountries.map(function (a) {
                    return a.toLowerCase()
                });
                this.p = k.filter(function (b) {
                    return a.indexOf(b.iso2) > -1
                })
            } else if (this.b.excludeCountries.length) {
                var b = this.b.excludeCountries.map(function (a) {
                    return a.toLowerCase()
                });
                this.p = k.filter(function (a) {
                    return b.indexOf(a.iso2) === -1
                })
            } else this.p = k
        },
        _d2: function () {
            this.q = {};
            for (var a = 0; a < this.p.length; a++) {
                var b = this.p[a];
                if (this._c(b.iso2, b.dialCode, b.priority), b.areaCodes)
                    for (var c = 0; c < b.areaCodes.length; c++) this._c(b.iso2, b.dialCode + b.areaCodes[c])
            }
        },
        _e: function () {
            this.preferredCountries = [];
            for (var a = 0; a < this.b.preferredCountries.length; a++) {
                var b = this.b.preferredCountries[a].toLowerCase(),
                    c = this._y(b, !1, !0);
                c && this.preferredCountries.push(c)
            }
        },
        _f: function () {
            this.a.attr("autocomplete", "off");
            var b = "intl-tel-input";
            this.b.allowDropdown && (b += " allow-dropdown"), this.b.separateDialCode && (b += " separate-dial-code"), this.a.wrap(a("<div>", {
                "class": b
            })), this.k = a("<div>", {
                "class": "flag-container"
            }).insertBefore(this.a);
            var c = a("<div>", {
                "class": "selected-flag"
            });
            c.appendTo(this.k), this.l = a("<div>", {
                "class": "iti-flag"
            }).appendTo(c), this.b.separateDialCode && (this.t = a("<div>", {
                "class": "selected-dial-code"
            }).appendTo(c)), this.b.allowDropdown ? (c.attr("tabindex", "0"), a("<div>", {
                "class": "iti-arrow"
            }).appendTo(c), this.m = a("<ul>", {
                "class": "country-list hide"
            }), this.preferredCountries.length && (this._g(this.preferredCountries, "preferred"), a("<li>", {
                "class": "divider"
            }).appendTo(this.m)), this._g(this.p, ""), this.o = this.m.children(".country"), this.b.dropdownContainer ? this.dropdown = a("<div>", {
                "class": "intl-tel-input iti-container"
            }).append(this.m) : this.m.appendTo(this.k)) : this.o = a(), this.b.hiddenInput && (this.hiddenInput = a("<input>", {
                type: "hidden",
                name: this.b.hiddenInput
            }).insertBefore(this.a))
        },
        getCookie: function (cname) {
            var allcookies = document.cookie;
            // Get all the cookies pairs in an array
            var cookiearray = allcookies.split(';').map((a) => { a = a.split('='); return { name: a[0].trim(), value: a[1] } });
            var filter = cookiearray.filter((a) => a.name == cname);
            // console.log(filter,cookiearray)
            if (filter.length) {
                return filter[0].value;
            } else {
                return 'en';
            }
        },
        _g: function (a, b) {
            var lang = this.getCookie('OBSIDIAM-LOCALE');
            // console.log('cookies', lang)
            for (var c = "", d = 0; d < a.length; d++) {
                var e = a[d];
                // c += "<li class='country " + b + "' data-dial-code='" + e.dialCode + "' data-country-code='" + (e.iso2 == 'do2' || e.iso2 == 'do3' ? 'do' : e.iso2) + "'>", c += "<div class='flag-box'><div class='iti-flag " + (e.iso2 == 'do2' || e.iso2 == 'do3' ? 'do' : e.iso2) + "'></div></div>", c += "<span class='country-name'>" + e.name[lang] + "</span>", c += "<span class='dial-code'>+" + e.dialCode + "</span>", c += "</li>"
                c += "<li class='country " + b + "' data-dial-code='" + e.dialCode + "' data-country-code='" + e.iso2 + "'>", c += "<div class='flag-box'><div class='iti-flag " + (e.iso2 == 'do2' || e.iso2 == 'do3' ? 'do' : e.iso2) + "'></div></div>", c += "<span class='country-name'>" + e.name[lang] + "</span>", c += "<span class='dial-code'>+" + e.dialCode + "</span>", c += "</li>"
            }
            this.m.append(c)
        },
        _h: function () {
            var a = this.a.val();
            this._af(a) && (!this._isRegionlessNanp(a) || this.b.nationalMode && !this.b.initialCountry) ? this._v(a) : "auto" !== this.b.initialCountry && (this.b.initialCountry ? this._z(this.b.initialCountry.toLowerCase()) : (this.j = this.preferredCountries.length ? this.preferredCountries[0].iso2 : this.p[0].iso2, a || this._z(this.j)), a || this.b.nationalMode || this.b.autoHideDialCode || this.b.separateDialCode || this.a.val("+" + this.s.dialCode)), a && this._u(a)
        },
        _i: function () {
            this._j(), this.b.autoHideDialCode && this._l(), this.b.allowDropdown && this._i1(), this.hiddenInput && this._initHiddenInputListener()
        },
        _initHiddenInputListener: function () {
            var a = this,
                b = this.a.closest("form");
            b.length && b.submit(function () {
                a.hiddenInput.val(a.getNumber())
            })
        },
        _i1: function () {
            var a = this,
                b = this.a.closest("label");
            b.length && b.on("click" + this.ns, function (b) {
                a.m.hasClass("hide") ? a.a.focus() : b.preventDefault()
            }), this.l.parent().on("click" + this.ns, function (b) {
                !a.m.hasClass("hide") || a.a.prop("disabled") || a.a.prop("readonly") || a._n()
            }), this.k.on("keydown" + a.ns, function (b) {
                !a.m.hasClass("hide") || b.which != i.b && b.which != i.c && b.which != i.j && b.which != i.d || (b.preventDefault(), b.stopPropagation(), a._n()), b.which == i.k && a._ac()
            })
        },
        _i2: function () {
            var c = this;
            this.b.utilsScript ? a.fn[f].windowLoaded ? a.fn[f].loadUtils(this.b.utilsScript, this.i) : a(b).on("load", function () {
                a.fn[f].loadUtils(c.b.utilsScript, c.i)
            }) : this.i.resolve(), "auto" === this.b.initialCountry ? this._i3() : this.h.resolve()
        },
        _i3: function () {
            a.fn[f].autoCountry ? this.handleAutoCountry() : a.fn[f].startedLoadingAutoCountry || (a.fn[f].startedLoadingAutoCountry = !0, "function" == typeof this.b.geoIpLookup && this.b.geoIpLookup(function (b) {
                a.fn[f].autoCountry = b.toLowerCase(), setTimeout(function () {
                    a(".intl-tel-input input").intlTelInput("handleAutoCountry")
                })
            }))
        },
        _j: function () {
            var a = this;
            this.a.on("keyup" + this.ns, function () {
                a._v(a.a.val()) && a._triggerCountryChange()
            }), this.a.on("cut" + this.ns + " paste" + this.ns, function () {
                setTimeout(function () {
                    a._v(a.a.val()) && a._triggerCountryChange()
                })
            })
        },
        _j2: function (a) {
            var b = this.a.attr("maxlength");
            return b && a.length > b ? a.substr(0, b) : a
        },
        _l: function () {
            var b = this;
            this.a.on("mousedown" + this.ns, function (a) {
                b.a.is(":focus") || b.a.val() || (a.preventDefault(), b.a.focus())
            }), this.a.on("focus" + this.ns, function (a) {
                b.a.val() || b.a.prop("readonly") || !b.s.dialCode || (b.a.val("+" + b.s.dialCode), b.a.one("keypress.plus" + b.ns, function (a) {
                    a.which == i.f && b.a.val("")
                }), setTimeout(function () {
                    var a = b.a[0];
                    if (b.d) {
                        var c = b.a.val().length;
                        a.setSelectionRange(c, c)
                    }
                }))
            });
            var c = this.a.prop("form");
            c && a(c).on("submit" + this.ns, function () {
                b._removeEmptyDialCode()
            }), this.a.on("blur" + this.ns, function () {
                b._removeEmptyDialCode()
            })
        },
        _removeEmptyDialCode: function () {
            var a = this.a.val();
            if ("+" == a.charAt(0)) {
                var b = this._m(a);
                b && this.s.dialCode != b || this.a.val("")
            }
            this.a.off("keypress.plus" + this.ns)
        },
        _m: function (a) {
            return a.replace(/\D/g, "")
        },
        _n: function () {
            this._o();
            var a = this.m.children(".active");
            a.length && (this._x(a), this._ad(a)), this._p(), this.l.children(".iti-arrow").addClass("up"), this.a.trigger("open:countrydropdown")
        },
        _o: function () {
            var c = this;
            if (this.b.dropdownContainer && this.dropdown.appendTo(this.b.dropdownContainer), this.n = this.m.removeClass("hide").outerHeight(), !this.g) {
                var d = this.a.offset(),
                    e = d.top,
                    f = a(b).scrollTop(),
                    g = e + this.a.outerHeight() + this.n < f + a(b).height(),
                    h = e - this.n > f;
                if (this.m.toggleClass("dropup", !g && h), this.b.dropdownContainer) {
                    var i = !g && h ? 0 : this.a.innerHeight();
                    this.dropdown.css({
                        top: e + i,
                        left: d.left
                    }), a(b).on("scroll" + this.ns, function () {
                        c._ac()
                    })
                }
            }
        },
        _p: function () {
            var b = this;
            this.m.on("mouseover" + this.ns, ".country", function (c) {
                b._x(a(this))
            }), this.m.on("click" + this.ns, ".country", function (c) {
                b._ab(a(this))
            });
            var d = !0;
            a("html").on("click" + this.ns, function (a) {
                d || b._ac(), d = !1
            });
            var e = "",
                f = null;
            a(c).on("keydown" + this.ns, function (a) {
                a.preventDefault(), a.which == i.b || a.which == i.c ? b._q(a.which) : a.which == i.d ? b._r() : a.which == i.e ? b._ac() : (a.which >= i.A && a.which <= i.Z || a.which == i.j) && (f && clearTimeout(f), e += String.fromCharCode(a.which), b._s(e), f = setTimeout(function () {
                    e = ""
                }, 1e3))
            })
        },
        _q: function (a) {
            var b = this.m.children(".highlight").first(),
                c = a == i.b ? b.prev() : b.next();
            c.length && (c.hasClass("divider") && (c = a == i.b ? c.prev() : c.next()), this._x(c), this._ad(c))
        },
        _r: function () {
            var a = this.m.children(".highlight").first();
            a.length && this._ab(a)
        },
        _s: function (a) {
            for (var b = 0; b < this.p.length; b++)
                if (this._t(this.p[b].name, a)) {
                    var c = this.m.children("[data-country-code=" + this.p[b].iso2 + "]").not(".preferred");
                    this._x(c), this._ad(c, !0);
                    break
                }
        },
        _t: function (a, b) {
            return a.substr(0, b.length).toUpperCase() == b
        },
        _u: function (a) {
            if (this.b.formatOnDisplay && b.intlTelInputUtils && this.s) {
                var c = this.b.separateDialCode || !this.b.nationalMode && "+" == a.charAt(0) ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                a = intlTelInputUtils.formatNumber(a, this.s.iso2, c)
            }
            a = this._ah(a), this.a.val(a)
        },
        _v: function (b) {
            b && this.b.nationalMode && "1" == this.s.dialCode && "+" != b.charAt(0) && ("1" != b.charAt(0) && (b = "1" + b), b = "+" + b);
            var c = this._af(b),
                d = null,
                e = this._m(b);
            if (c) {
                var f = this.q[this._m(c)],
                    g = a.inArray(this.s.iso2, f) > -1,
                    h = "+1" == c && e.length >= 4;
                if ((!("1" == this.s.dialCode) || !this._isRegionlessNanp(e)) && (!g || h))
                    for (var i = 0; i < f.length; i++)
                        if (f[i]) {
                            d = f[i];
                            break
                        }
            } else "+" == b.charAt(0) && e.length ? d = "" : b && "+" != b || (d = this.j);
            return null !== d && this._z(d)
        },
        _isRegionlessNanp: function (b) {
            var c = this._m(b);
            if ("1" == c.charAt(0)) {
                var d = c.substr(1, 3);
                return a.inArray(d, j) > -1
            }
            return !1
        },
        _x: function (a) {
            this.o.removeClass("highlight"), a.addClass("highlight")
        },
        _y: function (a, b, c) {
            for (var d = b ? k : this.p, e = 0; e < d.length; e++)
                if (d[e].iso2 == a) return d[e];
            if (c) return null;
            throw new Error("No country data for '" + a + "'")
        },
        _z: function (a) {
            var b = this.s.iso2 ? this.s : {};
            this.s = a ? this._y(a, !1, !1) : {}, this.s.iso2 && (this.j = this.s.iso2), this.l.attr("class", "iti-flag " + (a == 'do2' || a == 'do3' ? 'do' : a));
            var c = a ? this.s.name + ": +" + this.s.dialCode : "Unknown";
            if (this.l.parent().attr("title", c), this.b.separateDialCode) {
                var d = this.s.dialCode ? "+" + this.s.dialCode : "",
                    e = this.a.parent();
                b.dialCode && e.removeClass("iti-sdc-" + (b.dialCode.length + 1)), d && e.addClass("iti-sdc-" + d.length), this.t.text(d)
            }
            return this._aa(), this.o.removeClass("active"), a && this.o.find(".iti-flag." + a).first().closest(".country").addClass("active"), b.iso2 !== a
        },
        _aa: function () {
            var a = "aggressive" === this.b.autoPlaceholder || !this.e && (this.b.autoPlaceholder === !0 || "polite" === this.b.autoPlaceholder);
            if (b.intlTelInputUtils && a) {
                var c = intlTelInputUtils.numberType[this.b.placeholderNumberType],
                    d = this.s.iso2 ? intlTelInputUtils.getExampleNumber(this.s.iso2, this.b.nationalMode, c) : "";
                d = this._ah(d), "function" == typeof this.b.customPlaceholder && (d = this.b.customPlaceholder(d, this.s)), this.a.attr("placeholder", d)
            }
        },
        _ab: function (a) {
            var b = this._z(a.attr("data-country-code"));
            if (this._ac(), this._ae(a.attr("data-dial-code"), !0), this.a.focus(), this.d) {
                var c = this.a.val().length;
                this.a[0].setSelectionRange(c, c)
            }
            b && this._triggerCountryChange()
        },
        _ac: function () {
            this.m.addClass("hide"), this.l.children(".iti-arrow").removeClass("up"), a(c).off(this.ns), a("html").off(this.ns), this.m.off(this.ns), this.b.dropdownContainer && (this.g || a(b).off("scroll" + this.ns), this.dropdown.detach()), this.a.trigger("close:countrydropdown")
        },
        _ad: function (a, b) {
            var c = this.m,
                d = c.height(),
                e = c.offset().top,
                f = e + d,
                g = a.outerHeight(),
                h = a.offset().top,
                i = h + g,
                j = h - e + c.scrollTop(),
                k = d / 2 - g / 2;
            if (h < e) b && (j -= k), c.scrollTop(j);
            else if (i > f) {
                b && (j += k);
                var l = d - g;
                c.scrollTop(j - l)
            }
        },
        _ae: function (a, b) {
            var c, d = this.a.val();
            if (a = "+" + a, "+" == d.charAt(0)) {
                var e = this._af(d);
                c = e ? d.replace(e, a) : a
            } else {
                if (this.b.nationalMode || this.b.separateDialCode) return;
                if (d) c = a + d;
                else {
                    if (!b && this.b.autoHideDialCode) return;
                    c = a
                }
            }
            this.a.val(c)
        },
        _af: function (b) {
            var c = "";
            if ("+" == b.charAt(0))
                for (var d = "", e = 0; e < b.length; e++) {
                    var f = b.charAt(e);
                    if (a.isNumeric(f) && (d += f, this.q[d] && (c = b.substr(0, e + 1)), 4 == d.length)) break
                }
            return c
        },
        _ag: function () {
            var b, c = a.trim(this.a.val()),
                d = this.s.dialCode,
                e = this._m(c),
                f = "1" == e.charAt(0) ? e : "1" + e;
            return b = this.b.separateDialCode ? "+" + d : "+" != c.charAt(0) && "1" != c.charAt(0) && d && "1" == d.charAt(0) && 4 == d.length && d != f.substr(0, 4) ? d.substr(1) : "", b + c
        },
        _ah: function (a) {
            if (this.b.separateDialCode) {
                var b = this._af(a);
                if (b) {
                    null !== this.s.areaCodes && (b = "+" + this.s.dialCode);
                    var c = " " === a[b.length] || "-" === a[b.length] ? b.length + 1 : b.length;
                    a = a.substr(c)
                }
            }
            return this._j2(a)
        },
        _triggerCountryChange: function () {
            this.a.trigger("countrychange", this.s)
        },
        handleAutoCountry: function () {
            "auto" === this.b.initialCountry && (this.j = a.fn[f].autoCountry, this.a.val() || this.setCountry(this.j), this.h.resolve())
        },
        handleUtils: function () {
            b.intlTelInputUtils && (this.a.val() && this._u(this.a.val()), this._aa()), this.i.resolve()
        },
        destroy: function () {
            if (this.allowDropdown && (this._ac(), this.l.parent().off(this.ns), this.a.closest("label").off(this.ns)), this.b.autoHideDialCode) {
                var b = this.a.prop("form");
                b && a(b).off(this.ns)
            }
            this.a.off(this.ns), this.a.parent().before(this.a).remove()
        },
        getExtension: function () {
            return b.intlTelInputUtils ? intlTelInputUtils.getExtension(this._ag(), this.s.iso2) : ""
        },
        getNumber: function (a) {
            return b.intlTelInputUtils ? intlTelInputUtils.formatNumber(this._ag(), this.s.iso2, a) : ""
        },
        getNumberType: function () {
            return b.intlTelInputUtils ? intlTelInputUtils.getNumberType(this._ag(), this.s.iso2) : -99
        },
        getSelectedCountryData: function () {
            console.log(this.s)
            let p = {...this.s}
            p.iso2 = p.iso2.replace(/[^a-z]/gi, '')
            console.log(p)
            return p
        },
        getValidationError: function () {
            return b.intlTelInputUtils ? intlTelInputUtils.getValidationError(this._ag(), this.s.iso2) : -99
        },
        isValidNumber: function () {
            var c = a.trim(this._ag()),
                d = this.b.nationalMode ? this.s.iso2 : "";
            return b.intlTelInputUtils ? intlTelInputUtils.isValidNumber(c, d) : null
        },
        setCountry: function (a) {
            a = a.toLowerCase(), this.l.hasClass(a) || (this._z(a), this._ae(this.s.dialCode, !1), this._triggerCountryChange())
        },
        setNumber: function (a) {
            var b = this._v(a);
            this._u(a), b && this._triggerCountryChange()
        },
        setPlaceholderNumberType: function (a) {
            this.b.placeholderNumberType = a, this._aa()
        }
    }, a.fn[f] = function (b) {
        var c = arguments;
        if (b === d || "object" == typeof b) {
            var g = [];
            return this.each(function () {
                if (!a.data(this, "plugin_" + f)) {
                    var c = new e(this, b),
                        d = c._a();
                    g.push(d[0]), g.push(d[1]), a.data(this, "plugin_" + f, c)
                }
            }), a.when.apply(null, g)
        }
        if ("string" == typeof b && "_" !== b[0]) {
            var h;
            return this.each(function () {
                var d = a.data(this, "plugin_" + f);
                d instanceof e && "function" == typeof d[b] && (h = d[b].apply(d, Array.prototype.slice.call(c, 1))), "destroy" === b && a.data(this, "plugin_" + f, null)
            }), h !== d ? h : this
        }
    }, a.fn[f].getCountryData = function () {
        return k
    }, a.fn[f].loadUtils = function (b, c) {
        a.fn[f].loadedUtilsScript ? c && c.resolve() : (a.fn[f].loadedUtilsScript = !0, a.ajax({
            type: "GET",
            url: b,
            complete: function () {
                a(".intl-tel-input input").intlTelInput("handleUtils")
            },
            dataType: "script",
            cache: !0
        }))
    }, a.fn[f].defaults = h, a.fn[f].version = "12.1.2";
    for (var k = [
            [
                {
                    "en": "Afghanistan (‫افغانستان‬‎)",
                    "es": "Afganistan(‫افغانستان‬‎)",
                    "pt": "Afeganistão(‫افغانستان‬‎)"
                },
                "af",
                "93"
            ],
            [
                {
                    "en": "Albania (Shqipëri)",
                    "es": "Albania(Shqipëri)",
                    "pt": "Albânia(Shqipëri)"
                },
                "al",
                "355"
            ],
            [
                {
                    "en": "Algeria (‫الجزائر‬‎)",
                    "es": "Argelia(‫الجزائر‬‎)",
                    "pt": "Argélia(‫الجزائر‬‎)"
                },
                "dz",
                "213"
            ],
            [
                {
                    "en": "American Samoa",
                    "es": "Samoa Americana",
                    "pt": "Samoa Americana"
                },
                "as",
                "1684"
            ],
            [
                {
                    "en": "Andorra",
                    "es": "Andorra",
                    "pt": "Andorra"
                },
                "ad",
                "376"
            ],
            [
                {
                    "en": "Angola",
                    "es": "Angola",
                    "pt": "Angola"
                },
                "ao",
                "244"
            ],
            [
                {
                    "en": "Anguilla",
                    "es": "Anguilla",
                    "pt": "Anguilla"
                },
                "ai",
                "1264"
            ],
            [
                {
                    "en": "Antigua and Barbuda",
                    "es": "Antigua y Barbuda",
                    "pt": "Antígua e Barbuda"
                },
                "ag",
                "1268"
            ],
            [
                {
                    "en": "Argentina",
                    "es": "Argentina",
                    "pt": "Argentina"
                },
                "ar",
                "54"
            ],
            [
                {
                    "en": "Armenia (Հայաստան)",
                    "es": "Armenia(Հայաստան)",
                    "pt": "Armênia(Հայաստան)"
                },
                "am",
                "374"
            ],
            [
                {
                    "en": "Aruba",
                    "es": "Aruba",
                    "pt": "Aruba"
                },
                "aw",
                "297"
            ],
            [
                {
                    "en": "Australia",
                    "es": "Australia",
                    "pt": "Austrália"
                },
                "au",
                "61",
                0
            ],
            [
                {
                    "en": "Austria (Österreich)",
                    "es": "Austria(Österreich)",
                    "pt": "Áustria(Österreich)"
                },
                "at",
                "43"
            ],
            [
                {
                    "en": "Azerbaijan (Azərbaycan)",
                    "es": "Azerbaiyán(Azərbaycan)",
                    "pt": "Azerbaijão(Azərbaycan)"
                },
                "az",
                "994"
            ],
            [
                {
                    "en": "Bahamas",
                    "es": "Bahamas",
                    "pt": "Bahamas"
                },
                "bs",
                "1242"
            ],
            [
                {
                    "en": "Bahrain (‫البحرين‬‎)",
                    "es": "Baréin(‫البحرين‬‎)",
                    "pt": "Barém(‫البحرين‬‎)"
                },
                "bh",
                "973"
            ],
            [
                {
                    "en": "Bangladesh (বাংলাদেশ)",
                    "es": "Bangladesh(বাংলাদেশ)",
                    "pt": "Bangladesh(বাংলাদেশ)"
                },
                "bd",
                "880"
            ],
            [
                {
                    "en": "Barbados",
                    "es": "Barbados",
                    "pt": "Barbados"
                },
                "bb",
                "1246"
            ],
            [
                {
                    "en": "Belarus (Беларусь)",
                    "es": "Bielorrusia(Беларусь)",
                    "pt": "Bielorrússia(Беларусь)"
                },
                "by",
                "375"
            ],
            [
                {
                    "en": "Belgium (België)",
                    "es": "Bélgica(België)",
                    "pt": "Bélgica(België)"
                },
                "be",
                "32"
            ],
            [
                {
                    "en": "Belize",
                    "es": "Belize",
                    "pt": "Belize"
                },
                "bz",
                "501"
            ],
            [
                {
                    "en": "Benin (Bénin)",
                    "es": "Benin(Bénin)",
                    "pt": "Benin(Bénin)"
                },
                "bj",
                "229"
            ],
            [
                {
                    "en": "Bermuda",
                    "es": "Bermudas",
                    "pt": "Bermudas"
                },
                "bm",
                "1441"
            ],
            [
                {
                    "en": "Bhutan (འབྲུག)",
                    "es": "Bután(འབྲུག)",
                    "pt": "Butão(འབྲུག)"
                },
                "bt",
                "975"
            ],
            [
                {
                    "en": "Bolivia",
                    "es": "Bolívia",
                    "pt": "Bolívia"
                },
                "bo",
                "591"
            ],
            [
                {
                    "en": "Bosnia and Herzegovina (Босна и Херцеговина)",
                    "es": "Bosnia y Herzegovina(Босна и Херцеговина)",
                    "pt": "Bósnia e Herzegovina(Босна и Херцеговина)"
                },
                "ba",
                "387"
            ],
            [
                {
                    "en": "Botswana",
                    "es": "Botsuana",
                    "pt": "Botsuana"
                },
                "bw",
                "267"
            ],
            [
                {
                    "en": "Brazil (Brasil)",
                    "es": "Brasil(Brasil)",
                    "pt": "Brasil(Brasil)"
                },
                "br",
                "55"
            ],
            [
                {
                    "en": "British Indian Ocean Territory",
                    "es": "Territorio Británico del Océano Índico",
                    "pt": "Território Britânico do Oceano Índico"
                },
                "io",
                "246"
            ],
            [
                {
                    "en": "British Virgin Islands",
                    "es": "Islas Vírgenes Británicas",
                    "pt": "Ilhas Virgens Britânicas"
                },
                "vg",
                "1284"
            ],
            [
                {
                    "en": "Brunei",
                    "es": "Brunei",
                    "pt": "Brunei"
                },
                "bn",
                "673"
            ],
            [
                {
                    "en": "Bulgaria (България)",
                    "es": "Bulgaria(България)",
                    "pt": "Bulgária(България)"
                },
                "bg",
                "359"
            ],
            [
                {
                    "en": "Burkina Faso",
                    "es": "Burkina Faso",
                    "pt": "Burkina Faso"
                },
                "bf",
                "226"
            ],
            [
                {
                    "en": "Burundi (Uburundi)",
                    "es": "Burundi(Uburundi)",
                    "pt": "Burundi(Uburundi)"
                },
                "bi",
                "257"
            ],
            [
                {
                    "en": "Cambodia (កម្ពុជា)",
                    "es": "Camboya(កម្ពុជា)",
                    "pt": "Camboja(កម្ពុជា)"
                },
                "kh",
                "855"
            ],
            [
                {
                    "en": "Cameroon (Cameroun)",
                    "es": "Camerún(Cameroun)",
                    "pt": "Camarões(Cameroun)"
                },
                "cm",
                "237"
            ],
            [
                {
                    "en": "Canada",
                    "es": "Canadá",
                    "pt": "Canadá"
                },
                "ca",
                "1",
                1,
                [
                    "204",
                    "226",
                    "236",
                    "249",
                    "250",
                    "289",
                    "306",
                    "343",
                    "365",
                    "387",
                    "403",
                    "416",
                    "418",
                    "431",
                    "437",
                    "438",
                    "450",
                    "506",
                    "514",
                    "519",
                    "548",
                    "579",
                    "581",
                    "587",
                    "604",
                    "613",
                    "639",
                    "647",
                    "672",
                    "705",
                    "709",
                    "742",
                    "778",
                    "780",
                    "782",
                    "807",
                    "819",
                    "825",
                    "867",
                    "873",
                    "902",
                    "905"
                ]
            ],
            [
                {
                    "en": "Cape Verde (Kabu Verdi)",
                    "es": "Cabo Verde(Kabu Verdi)",
                    "pt": "Cabo Verde(Kabu Verdi)"
                },
                "cv",
                "238"
            ],
            [
                {
                    "en": "Caribbean Netherlands",
                    "es": "Caribe neerlandés",
                    "pt": "Caraíbas Holanda"
                },
                "bq",
                "599",
                1
            ],
            [
                {
                    "en": "Cayman Islands",
                    "es": "Islas Caimán",
                    "pt": "Ilhas Cayman"
                },
                "ky",
                "1345"
            ],
            [
                {
                    "en": "Central African Republic (République centrafricaine)",
                    "es": "República Centroafricana(République centrafricaine)",
                    "pt": "República Centro-Africana(République centrafricaine)"
                },
                "cf",
                "236"
            ],
            [
                {
                    "en": "Chad (Tchad)",
                    "es": "Chad(Tchad)",
                    "pt": "Chade(Tchad)"
                },
                "td",
                "235"
            ],
            [
                {
                    "en": "Chile",
                    "es": "Chile",
                    "pt": "Chile"
                },
                "cl",
                "56"
            ],
            [
                {
                    "en": "China (中国)",
                    "es": "China(中国)",
                    "pt": "China(中国)"
                },
                "cn",
                "86"
            ],
            [
                {
                    "en": "Christmas Island",
                    "es": "Isla de Navidad",
                    "pt": "Ilha do Natal"
                },
                "cx",
                "61",
                2
            ],
            [
                {
                    "en": "Cocos (Keeling) Islands",
                    "es": "Cocos(Keeling) Islands",
                    "pt": "Cocos(Keeling) Islands"
                },
                "cc",
                "61",
                1
            ],
            [
                {
                    "en": "Colombia",
                    "es": "Colombia",
                    "pt": "Colômbia"
                },
                "co",
                "57"
            ],
            [
                {
                    "en": "Comoros (‫جزر القمر‬‎)",
                    "es": "Comoras(‫جزر القمر‬‎)",
                    "pt": "Comores(‫جزر القمر‬‎)"
                },
                "km",
                "269"
            ],
            [
                {
                    "en": "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
                    "es": "Congo(DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
                    "pt": "Congo(DRC) (Jamhuri ya Kidemokrasia ya Kongo)"
                },
                "cd",
                "243"
            ],
            [
                {
                    "en": "Congo (Republic) (Congo-Brazzaville)",
                    "es": "Congo(República) (Congo-Brazzaville)",
                    "pt": "Congo(Republic) (Congo-Brazzaville)"
                },
                "cg",
                "242"
            ],
            [
                {
                    "en": "Cook Islands",
                    "es": "Islas Cook",
                    "pt": "Ilhas Cook"
                },
                "ck",
                "682"
            ],
            [
                {
                    "en": "Costa Rica",
                    "es": "Costa Rica",
                    "pt": "Costa Rica"
                },
                "cr",
                "506"
            ],
            [
                {
                    "en": "Côte d’Ivoire",
                    "es": "Costa de Marfil",
                    "pt": "Costa do Marfim"
                },
                "ci",
                "225"
            ],
            [
                {
                    "en": "Croatia (Hrvatska)",
                    "es": "Croacia(Hrvatska)",
                    "pt": "Croácia(Hrvatska)"
                },
                "hr",
                "385"
            ],
            // [
            //     {
            //         "en": "Cuba",
            //         "es": "Cuba",
            //         "pt": "Cuba"
            //     },
            //     "cu",
            //     "53"
            // ],
            [
                {
                    "en": "Curaçao",
                    "es": "Curazao",
                    "pt": "Curaçao"
                },
                "cw",
                "599",
                0
            ],
            [
                {
                    "en": "Cyprus (Κύπρος)",
                    "es": "Chipre(Κύπρος)",
                    "pt": "Chipre(Κύπρος)"
                },
                "cy",
                "357"
            ],
            [
                {
                    "en": "Czech Republic (Česká republika)",
                    "es": "República Checa(Česká republika)",
                    "pt": "República Checa(Česká republika)"
                },
                "cz",
                "420"
            ],
            [
                {
                    "en": "Denmark (Danmark)",
                    "es": "Dinamarca(Danmark)",
                    "pt": "Dinamarca(Danmark)"
                },
                "dk",
                "45"
            ],
            [
                {
                    "en": "Djibouti",
                    "es": "Djibuti",
                    "pt": "Djibuti"
                },
                "dj",
                "253"
            ],
            [
                {
                    "en": "Dominica",
                    "es": "Dominica",
                    "pt": "Dominica"
                },
                "dm",
                "1767"
            ],
            [
                {
                    "en": "Dominican Republic (República Dominicana)",
                    "es": "República Dominicana(República Dominicana)",
                    "pt": "República Dominicana(República Dominicana)"
                },
                "do",
                "1809",
                // 2,
                // [
                //     "809",
                //     "829",
                //     "849"
                // ]
            ],
            [
                {
                    "en": "Dominican Republic (República Dominicana)",
                    "es": "República Dominicana(República Dominicana)",
                    "pt": "República Dominicana(República Dominicana)"
                },
                "do2",
                "1829",
    
            ],
            [
                {
                    "en": "Dominican Republic (República Dominicana)",
                    "es": "República Dominicana(República Dominicana)",
                    "pt": "República Dominicana(República Dominicana)"
                },
                "do3",
                "1849",
    
            ],
            [
                {
                    "en": "Ecuador",
                    "es": "Ecuador",
                    "pt": "Equador"
                },
                "ec",
                "593"
            ],
            [
                {
                    "en": "Egypt (‫مصر‬‎)",
                    "es": "Egito(‫مصر‬‎)",
                    "pt": "Egito(‫مصر‬‎)"
                },
                "eg",
                "20"
            ],
            [
                {
                    "en": "El Salvador",
                    "es": "El Salvador",
                    "pt": "O salvador"
                },
                "sv",
                "503"
            ],
            [
                {
                    "en": "Equatorial Guinea (Guinea Ecuatorial)",
                    "es": "Guinea Equatorial(Guinea Ecuatorial)",
                    "pt": "Guiné Equatorial(Guinea Ecuatorial)"
                },
                "gq",
                "240"
            ],
            [
                {
                    "en": "Eritrea",
                    "es": "Eritrea",
                    "pt": "Eritreia"
                },
                "er",
                "291"
            ],
            [
                {
                    "en": "Estonia (Eesti)",
                    "es": "Estonia(Eesti)",
                    "pt": "Estônia(Eesti)"
                },
                "ee",
                "372"
            ],
            [
                {
                    "en": "Ethiopia",
                    "es": "Etiopía",
                    "pt": "Etiópia"
                },
                "et",
                "251"
            ],
            [
                {
                    "en": "Falkland Islands (Islas Malvinas)",
                    "es": "Islas Malvinas",
                    "pt": "Ilhas Falkland(Islas Malvinas)"
                },
                "fk",
                "500"
            ],
            [
                {
                    "en": "Faroe Islands (Føroyar)",
                    "es": "Islas Faroe(Føroyar)",
                    "pt": "ilhas Faroe(Føroyar)"
                },
                "fo",
                "298"
            ],
            [
                {
                    "en": "Fiji",
                    "es": "Fiji",
                    "pt": "Fiji"
                },
                "fj",
                "679"
            ],
            [
                {
                    "en": "Finland (Suomi)",
                    "es": "Finlandia(Suomi)",
                    "pt": "Finlândia(Suomi)"
                },
                "fi",
                "358",
                0
            ],
            [
                {
                    "en": "France",
                    "es": "Francia",
                    "pt": "França"
                },
                "fr",
                "33"
            ],
            [
                {
                    "en": "French Guiana (Guyane française)",
                    "es": "Guyana Francesa(Guyane française)",
                    "pt": "Guiana Francesa(Guyane française)"
                },
                "gf",
                "594"
            ],
            [
                {
                    "en": "French Polynesia (Polynésie française)",
                    "es": "Polinesia francesa(Polynésie française)",
                    "pt": "Polinésia Francesa(Polynésie française)"
                },
                "pf",
                "689"
            ],
            [
                {
                    "en": "Gabon",
                    "es": "Gabon",
                    "pt": "Gabão"
                },
                "ga",
                "241"
            ],
            [
                {
                    "en": "Gambia",
                    "es": "Gambia",
                    "pt": "Gâmbia"
                },
                "gm",
                "220"
            ],
            [
                {
                    "en": "Georgia (საქართველო)",
                    "es": "Georgia(საქართველო)",
                    "pt": "Geórgia(საქართველო)"
                },
                "ge",
                "995"
            ],
            [
                {
                    "en": "Germany (Deutschland)",
                    "es": "Alemania(Deutschland)",
                    "pt": "Alemanha(Deutschland)"
                },
                "de",
                "49"
            ],
            [
                {
                    "en": "Ghana (Gaana)",
                    "es": "Gana(Gaana)",
                    "pt": "Gana(Gaana)"
                },
                "gh",
                "233"
            ],
            [
                {
                    "en": "Gibraltar",
                    "es": "Gibraltar",
                    "pt": "Gibraltar"
                },
                "gi",
                "350"
            ],
            [
                {
                    "en": "Greece (Ελλάδα)",
                    "es": "Grecia(Ελλάδα)",
                    "pt": "Grécia(Ελλάδα)"
                },
                "gr",
                "30"
            ],
            [
                {
                    "en": "Greenland (Kalaallit Nunaat)",
                    "es": "Groenlandia(Kalaallit Nunaat)",
                    "pt": "Gronelândia(Kalaallit Nunaat)"
                },
                "gl",
                "299"
            ],
            [
                {
                    "en": "Grenada",
                    "es": "Granada",
                    "pt": "Granada"
                },
                "gd",
                "1473"
            ],
            [
                {
                    "en": "Guadeloupe",
                    "es": "Guadalupe",
                    "pt": "Guadalupe"
                },
                "gp",
                "590",
                0
            ],
            [
                {
                    "en": "Guam",
                    "es": "Guam",
                    "pt": "Guam"
                },
                "gu",
                "1671"
            ],
            [
                {
                    "en": "Guatemala",
                    "es": "Guatemala",
                    "pt": "Guatemala"
                },
                "gt",
                "502"
            ],
            [
                {
                    "en": "Guernsey",
                    "es": "Guernsey",
                    "pt": "Guernsey"
                },
                "gg",
                "44",
                1
            ],
            [
                {
                    "en": "Guinea (Guinée)",
                    "es": "Guinea(Guinée)",
                    "pt": "Guiné(Guinée)"
                },
                "gn",
                "224"
            ],
            [
                {
                    "en": "Guinea-Bissau (Guiné Bissau)",
                    "es": "Guinea-Bissau(Guiné Bissau)",
                    "pt": "Guiné-Bissau(Guiné Bissau)"
                },
                "gw",
                "245"
            ],
            [
                {
                    "en": "Guyana",
                    "es": "Guyana",
                    "pt": "Guiana"
                },
                "gy",
                "592"
            ],
            [
                {
                    "en": "Haiti",
                    "es": "Haiti",
                    "pt": "Haiti"
                },
                "ht",
                "509"
            ],
            [
                {
                    "en": "Honduras",
                    "es": "Honduras",
                    "pt": "Honduras"
                },
                "hn",
                "504"
            ],
            [
                {
                    "en": "Hong Kong (香港)",
                    "es": "Hong Kong(香港)",
                    "pt": "Hong Kong(香港)"
                },
                "hk",
                "852"
            ],
            [
                {
                    "en": "Hungary (Magyarország)",
                    "es": "Hungria(Magyarország)",
                    "pt": "Hungria(Magyarország)"
                },
                "hu",
                "36"
            ],
            [
                {
                    "en": "Iceland (Ísland)",
                    "es": "Islandia(Ísland)",
                    "pt": "Islândia(Ísland)"
                },
                "is",
                "354"
            ],
            [
                {
                    "en": "India (भारत)",
                    "es": "India(भारत)",
                    "pt": "Índia(भारत)"
                },
                "in",
                "91"
            ],
            [
                {
                    "en": "Indonesia",
                    "es": "Indonesia",
                    "pt": "Indonésia"
                },
                "id",
                "62"
            ],
            // [
            //     {
            //         "en": "Iran (‫ایران‬‎)",
            //         "es": "Eu corri(‫ایران‬‎)",
            //         "pt": "Eu corri(‫ایران‬‎)"
            //     },
            //     "ir",
            //     "98"
            // ],
            [
                {
                    "en": "Iraq (‫العراق‬‎)",
                    "es": "Iraq(‫العراق‬‎)",
                    "pt": "Iraque(‫العراق‬‎)"
                },
                "iq",
                "964"
            ],
            [
                {
                    "en": "Ireland",
                    "es": "Irlanda",
                    "pt": "Irlanda"
                },
                "ie",
                "353"
            ],
            [
                {
                    "en": "Isle of Man",
                    "es": "Isla de Man",
                    "pt": "Ilha de Man"
                },
                "im",
                "44",
                2
            ],
            [
                {
                    "en": "Israel (‫ישראל‬‎)",
                    "es": "Israel(‫ישראל‬‎)",
                    "pt": "Israel(‫ישראל‬‎)"
                },
                "il",
                "972"
            ],
            [
                {
                    "en": "Italy (Italia)",
                    "es": "Italia(Italia)",
                    "pt": "Itália(Italia)"
                },
                "it",
                "39",
                0
            ],
            [
                {
                    "en": "Jamaica",
                    "es": "Jamaica",
                    "pt": "Jamaica"
                },
                "jm",
                "1876"
            ],
            [
                {
                    "en": "Japan (日本)",
                    "es": "Japon(日本)",
                    "pt": "Japão(日本)"
                },
                "jp",
                "81"
            ],
            [
                {
                    "en": "Jersey",
                    "es": "Jersey",
                    "pt": "Jersey"
                },
                "je",
                "44",
                3
            ],
            [
                {
                    "en": "Jordan (‫الأردن‬‎)",
                    "es": "Jordania(‫الأردن‬‎)",
                    "pt": "Jordânia(‫الأردن‬‎)"
                },
                "jo",
                "962"
            ],
            [
                {
                    "en": "Kazakhstan (Казахстан)",
                    "es": "Kazajistán(Казахстан)",
                    "pt": "Cazaquistão(Казахстан)"
                },
                "kz",
                "7",
                1
            ],
            [
                {
                    "en": "Kenya",
                    "es": "Kenya",
                    "pt": "Quênia"
                },
                "ke",
                "254"
            ],
            [
                {
                    "en": "Kiribati",
                    "es": "Kiribati",
                    "pt": "Kiribati"
                },
                "ki",
                "686"
            ],
            [
                {
                    "en": "Kosovo",
                    "es": "Kosovo",
                    "pt": "Kosovo"
                },
                "xk",
                "383"
            ],
            [
                {
                    "en": "Kuwait (‫الكويت‬‎)",
                    "es": "Kuwait(‫الكويت‬‎)",
                    "pt": "Kuwait(‫الكويت‬‎)"
                },
                "kw",
                "965"
            ],
            [
                {
                    "en": "Kyrgyzstan (Кыргызстан)",
                    "es": "Kirguistán(Кыргызстан)",
                    "pt": "Quirguistão(Кыргызстан)"
                },
                "kg",
                "996"
            ],
            [
                {
                    "en": "Laos (ລາວ)",
                    "es": "Laos(ລາວ)",
                    "pt": "Laos(ລາວ)"
                },
                "la",
                "856"
            ],
            [
                {
                    "en": "Latvia (Latvija)",
                    "es": "Letonia(Latvija)",
                    "pt": "Letônia(Latvija)"
                },
                "lv",
                "371"
            ],
            [
                {
                    "en": "Lebanon (‫لبنان‬‎)",
                    "es": "Libano(‫لبنان‬‎)",
                    "pt": "Líbano(‫لبنان‬‎)"
                },
                "lb",
                "961"
            ],
            [
                {
                    "en": "Lesotho",
                    "es": "Lesoto",
                    "pt": "Lesoto"
                },
                "ls",
                "266"
            ],
            [
                {
                    "en": "Liberia",
                    "es": "Liberia",
                    "pt": "Libéria"
                },
                "lr",
                "231"
            ],
            [
                {
                    "en": "Libya (‫ليبيا‬‎)",
                    "es": "Libia(‫ليبيا‬‎)",
                    "pt": "Líbia(‫ليبيا‬‎)"
                },
                "ly",
                "218"
            ],
            [
                {
                    "en": "Liechtenstein",
                    "es": "Liechtenstein",
                    "pt": "Liechtenstein"
                },
                "li",
                "423"
            ],
            [
                {
                    "en": "Lithuania (Lietuva)",
                    "es": "Lituania(Lietuva)",
                    "pt": "Lituânia(Lietuva)"
                },
                "lt",
                "370"
            ],
            [
                {
                    "en": "Luxembourg",
                    "es": "Luxemburgo",
                    "pt": "Luxemburgo"
                },
                "lu",
                "352"
            ],
            [
                {
                    "en": "Macau (澳門)",
                    "es": "Macau(澳門)",
                    "pt": "Macau(澳門)"
                },
                "mo",
                "853"
            ],
            [
                {
                    "en": "Macedonia (FYROM) (Македонија)",
                    "es": "Macedonia(FYROM) (Македонија)",
                    "pt": "Macedônia(FYROM) (Македонија)"
                },
                "mk",
                "389"
            ],
            [
                {
                    "en": "Madagascar (Madagasikara)",
                    "es": "Madagascar(Madagasikara)",
                    "pt": "Madagáscar(Madagasikara)"
                },
                "mg",
                "261"
            ],
            [
                {
                    "en": "Malawi",
                    "es": "Malawi",
                    "pt": "Malawi"
                },
                "mw",
                "265"
            ],
            [
                {
                    "en": "Malaysia",
                    "es": "Malasia",
                    "pt": "Malásia"
                },
                "my",
                "60"
            ],
            [
                {
                    "en": "Maldives",
                    "es": "Maldivas",
                    "pt": "Maldivas"
                },
                "mv",
                "960"
            ],
            [
                {
                    "en": "Mali",
                    "es": "mali",
                    "pt": "mali"
                },
                "ml",
                "223"
            ],
            [
                {
                    "en": "Malta",
                    "es": "Malta",
                    "pt": "Malta"
                },
                "mt",
                "356"
            ],
            [
                {
                    "en": "Marshall Islands",
                    "es": "Islas Marshall",
                    "pt": "Ilhas Marshall"
                },
                "mh",
                "692"
            ],
            [
                {
                    "en": "Martinique",
                    "es": "Martinica",
                    "pt": "Martinica"
                },
                "mq",
                "596"
            ],
            [
                {
                    "en": "Mauritania (‫موريتانيا‬‎)",
                    "es": "Mauritania(‫موريتانيا‬‎)",
                    "pt": "Mauritânia(‫موريتانيا‬‎)"
                },
                "mr",
                "222"
            ],
            [
                {
                    "en": "Mauritius (Moris)",
                    "es": "Mauricia(Moris)",
                    "pt": "Maurícia(Moris)"
                },
                "mu",
                "230"
            ],
            [
                {
                    "en": "Mayotte",
                    "es": "Mayotte",
                    "pt": "Mayotte"
                },
                "yt",
                "262",
                1
            ],
            [
                {
                    "en": "Mexico (México)",
                    "es": "México(México)",
                    "pt": "México(México)"
                },
                "mx",
                "52"
            ],
            [
                {
                    "en": "Micronesia",
                    "es": "Micronesia",
                    "pt": "Micronésia"
                },
                "fm",
                "691"
            ],
            [
                {
                    "en": "Moldova (Republica Moldova)",
                    "es": "Moldavia(Republica Moldova)",
                    "pt": "Moldávia(Republica Moldova)"
                },
                "md",
                "373"
            ],
            [
                {
                    "en": "Monaco",
                    "es": "Monaco",
                    "pt": "Mônaco"
                },
                "mc",
                "377"
            ],
            [
                {
                    "en": "Mongolia (Монгол)",
                    "es": "Mongolia(Монгол)",
                    "pt": "Mongólia(Монгол)"
                },
                "mn",
                "976"
            ],
            [
                {
                    "en": "Montenegro (Crna Gora)",
                    "es": "Montenegro(Crna Gora)",
                    "pt": "Montenegro(Crna Gora)"
                },
                "me",
                "382"
            ],
            [
                {
                    "en": "Montserrat",
                    "es": "Montserrat",
                    "pt": "Montserrat"
                },
                "ms",
                "1664"
            ],
            [
                {
                    "en": "Morocco (‫المغرب‬‎)",
                    "es": "Marruecos(‫المغرب‬‎)",
                    "pt": "Marrocos(‫المغرب‬‎)"
                },
                "ma",
                "212",
                0
            ],
            [
                {
                    "en": "Mozambique (Moçambique)",
                    "es": "Mozambique(Moçambique)",
                    "pt": "Moçambique(Moçambique)"
                },
                "mz",
                "258"
            ],
            [
                {
                    "en": "Myanmar (Burma) (မြန်မာ)",
                    "es": "Myanmar(Burma) (မြန်မာ)",
                    "pt": "Myanmar(Burma) (မြန်မာ)"
                },
                "mm",
                "95"
            ],
            [
                {
                    "en": "Namibia (Namibië)",
                    "es": "Namibia(Namibië)",
                    "pt": "Namíbia(Namibië)"
                },
                "na",
                "264"
            ],
            [
                {
                    "en": "Nauru",
                    "es": "Nauru",
                    "pt": "Nauru"
                },
                "nr",
                "674"
            ],
            [
                {
                    "en": "Nepal (नेपाल)",
                    "es": "Nepal(नेपाल)",
                    "pt": "Nepal(नेपाल)"
                },
                "np",
                "977"
            ],
            [
                {
                    "en": "Netherlands (Nederland)",
                    "es": "Países Bajos(Nederland)",
                    "pt": "Países Baixos(Nederland)"
                },
                "nl",
                "31"
            ],
            [
                {
                    "en": "New Caledonia (Nouvelle-Calédonie)",
                    "es": "Nueva Caledonia(Nouvelle-Calédonie)",
                    "pt": "Nova Caledônia(Nouvelle-Calédonie)"
                },
                "nc",
                "687"
            ],
            [
                {
                    "en": "New Zealand",
                    "es": "Nueva Zelanda",
                    "pt": "Nova Zelândia"
                },
                "nz",
                "64"
            ],
            [
                {
                    "en": "Nicaragua",
                    "es": "Nicaragua",
                    "pt": "Nicarágua"
                },
                "ni",
                "505"
            ],
            [
                {
                    "en": "Niger (Nijar)",
                    "es": "Níger(Nijar)",
                    "pt": "Níger(Nijar)"
                },
                "ne",
                "227"
            ],
            [
                {
                    "en": "Nigeria",
                    "es": "Nigeria",
                    "pt": "Nigéria"
                },
                "ng",
                "234"
            ],
            [
                {
                    "en": "Niue",
                    "es": "Niue",
                    "pt": "Niue"
                },
                "nu",
                "683"
            ],
            [
                {
                    "en": "Norfolk Island",
                    "es": "Isla Norfolk",
                    "pt": "Ilha Norfolk"
                },
                "nf",
                "672"
            ],
            // [
            //     {
            //         "en": "North Korea (조선 민주주의 인민 공화국)",
            //         "es": "Coreia do Norte(조선 민주주의 인민 공화국)",
            //         "pt": "Coreia do Norte(조선 민주주의 인민 공화국)"
            //     },
            //     "kp",
            //     "850"
            // ],
            [
                {
                    "en": "Northern Mariana Islands",
                    "es": "Islas Marianas del Norte",
                    "pt": "Ilhas Marianas do Norte"
                },
                "mp",
                "1670"
            ],
            [
                {
                    "en": "Norway (Norge)",
                    "es": "Noruega(Norge)",
                    "pt": "Noruega(Norge)"
                },
                "no",
                "47",
                0
            ],
            [
                {
                    "en": "Oman (‫عُمان‬‎)",
                    "es": "Oman(‫عُمان‬‎)",
                    "pt": "Omã(‫عُمان‬‎)"
                },
                "om",
                "968"
            ],
            [
                {
                    "en": "Pakistan (‫پاکستان‬‎)",
                    "es": "Pakistán(‫پاکستان‬‎)",
                    "pt": "Paquistão(‫پاکستان‬‎)"
                },
                "pk",
                "92"
            ],
            [
                {
                    "en": "Palau",
                    "es": "Palau",
                    "pt": "Palau"
                },
                "pw",
                "680"
            ],
            [
                {
                    "en": "Palestine (‫فلسطين‬‎)",
                    "es": "Palestina(‫فلسطين‬‎)",
                    "pt": "Palestina(‫فلسطين‬‎)"
                },
                "ps",
                "970"
            ],
            [
                {
                    "en": "Panama (Panamá)",
                    "es": "Panamá(Panamá)",
                    "pt": "Panamá(Panamá)"
                },
                "pa",
                "507"
            ],
            [
                {
                    "en": "Papua New Guinea",
                    "es": "Papúa Nueva Guinea",
                    "pt": "Papua Nova Guiné"
                },
                "pg",
                "675"
            ],
            [
                {
                    "en": "Paraguay",
                    "es": "Paraguay",
                    "pt": "Paraguai"
                },
                "py",
                "595"
            ],
            [
                {
                    "en": "Peru (Perú)",
                    "es": "Perú(Perú)",
                    "pt": "Peru(Perú)"
                },
                "pe",
                "51"
            ],
            [
                {
                    "en": "Philippines",
                    "es": "Filipinas",
                    "pt": "Filipinas"
                },
                "ph",
                "63"
            ],
            [
                {
                    "en": "Poland (Polska)",
                    "es": "Polonia(Polska)",
                    "pt": "Polônia(Polska)"
                },
                "pl",
                "48"
            ],
            [
                {
                    "en": "Portugal",
                    "es": "Portugal",
                    "pt": "Portugal"
                },
                "pt",
                "351"
            ],
            [
                {
                    "en": "Puerto Rico",
                    "es": "Puerto Rico",
                    "pt": "Porto Rico"
                },
                "pr",
                "1",
                3,
                [
                    "787",
                    "939"
                ]
            ],
            [
                {
                    "en": "Qatar (‫قطر‬‎)",
                    "es": "Qatar(‫قطر‬‎)",
                    "pt": "Catar(‫قطر‬‎)"
                },
                "qa",
                "974"
            ],
            [
                {
                    "en": "Réunion (La Réunion)",
                    "es": "Reunión(La Réunion)",
                    "pt": "Reunião(La Réunion)"
                },
                "re",
                "262",
                0
            ],
            [
                {
                    "en": "Romania (România)",
                    "es": "Rumanía(România)",
                    "pt": "Romênia(România)"
                },
                "ro",
                "40"
            ],
            [
                {
                    "en": "Russia (Россия)",
                    "es": "Rusia(Россия)",
                    "pt": "Rússia(Россия)"
                },
                "ru",
                "7",
                0
            ],
            [
                {
                    "en": "Rwanda",
                    "es": "Ruanda",
                    "pt": "Ruanda"
                },
                "rw",
                "250"
            ],
            [
                {
                    "en": "Saint Barthélemy",
                    "es": "San Bartolome",
                    "pt": "São Bartolomeu"
                },
                "bl",
                "590",
                1
            ],
            [
                {
                    "en": "Saint Helena",
                    "es": "Santa Helena",
                    "pt": "Santa Helena"
                },
                "sh",
                "290"
            ],
            [
                {
                    "en": "Saint Kitts and Nevis",
                    "es": "San Cristóbal y Nieves",
                    "pt": "São Cristóvão e Nevis"
                },
                "kn",
                "1869"
            ],
            [
                {
                    "en": "Saint Lucia",
                    "es": "Santa Lucía",
                    "pt": "Santa Lúcia"
                },
                "lc",
                "1758"
            ],
            [
                {
                    "en": "Saint Martin (Saint-Martin (partie française))",
                    "es": "San Martín(Saint-Martin (partie française))",
                    "pt": "Saint Martin(Saint-Martin (partie française))"
                },
                "mf",
                "590",
                2
            ],
            [
                {
                    "en": "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
                    "es": "San Pedro y Miquelón(Saint-Pierre-et-Miquelon)",
                    "pt": "São Pedro e Miquelon(Saint-Pierre-et-Miquelon)"
                },
                "pm",
                "508"
            ],
            [
                {
                    "en": "Saint Vincent and the Grenadines",
                    "es": "San Vicente y las Granadinas",
                    "pt": "São Vicente e Granadinas"
                },
                "vc",
                "1784"
            ],
            [
                {
                    "en": "Samoa",
                    "es": "Samoa",
                    "pt": "Samoa"
                },
                "ws",
                "685"
            ],
            [
                {
                    "en": "San Marino",
                    "es": "San Marino",
                    "pt": "San Marino"
                },
                "sm",
                "378"
            ],
            [
                {
                    "en": "São Tomé and Príncipe (São Tomé e Príncipe)",
                    "es": "Santo Tomé y Príncipe (São Tomé e Príncipe)",
                    "pt": "São Tomé and Príncipe (São Tomé e Príncipe)"
                },
                "st",
                "239"
            ],
            [
                {
                    "en": "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
                    "es": "Arabia Saudita(‫المملكة العربية السعودية‬‎)",
                    "pt": "Arábia Saudita(‫المملكة العربية السعودية‬‎)"
                },
                "sa",
                "966"
            ],
            [
                {
                    "en": "Senegal (Sénégal)",
                    "es": "Senegal(Sénégal)",
                    "pt": "Senegal(Sénégal)"
                },
                "sn",
                "221"
            ],
            [
                {
                    "en": "Serbia (Србија)",
                    "es": "Serbia(Србија)",
                    "pt": "Sérvia(Србија)"
                },
                "rs",
                "381"
            ],
            [
                {
                    "en": "Seychelles",
                    "es": "Seychelles",
                    "pt": "Seychelles"
                },
                "sc",
                "248"
            ],
            [
                {
                    "en": "Sierra Leone",
                    "es": "Seerra Leona",
                    "pt": "Serra Leoa"
                },
                "sl",
                "232"
            ],
            [
                {
                    "en": "Singapore",
                    "es": "Singapure",
                    "pt": "Cingapura"
                },
                "sg",
                "65"
            ],
            [
                {
                    "en": "Sint Maarten",
                    "es": "San Martin",
                    "pt": "São Martinho"
                },
                "sx",
                "1721"
            ],
            [
                {
                    "en": "Slovakia (Slovensko)",
                    "es": "Eslovaquia(Slovensko)",
                    "pt": "Eslováquia(Slovensko)"
                },
                "sk",
                "421"
            ],
            [
                {
                    "en": "Slovenia (Slovenija)",
                    "es": "Eslovenia(Slovenija)",
                    "pt": "Eslovênia(Slovenija)"
                },
                "si",
                "386"
            ],
            [
                {
                    "en": "Solomon Islands",
                    "es": "Islas Salomon",
                    "pt": "Ilhas Salomão"
                },
                "sb",
                "677"
            ],
            [
                {
                    "en": "Somalia (Soomaaliya)",
                    "es": "Somalia(Soomaaliya)",
                    "pt": "Somália(Soomaaliya)"
                },
                "so",
                "252"
            ],
            [
                {
                    "en": "South Africa",
                    "es": "Sudáfrica",
                    "pt": "África do Sul"
                },
                "za",
                "27"
            ],
            [
                {
                    "en": "South Korea (대한민국)",
                    "es": "Corea del Sur(대한민국)",
                    "pt": "Coreia do Sul(대한민국)"
                },
                "kr",
                "82"
            ],
            [
                {
                    "en": "South Sudan (‫جنوب السودان‬‎)",
                    "es": "Sudán del Sur(‫جنوب السودان‬‎)",
                    "pt": "Sudão do Sul(‫جنوب السودان‬‎)"
                },
                "ss",
                "211"
            ],
            [
                {
                    "en": "Spain (España)",
                    "es": "España(España)",
                    "pt": "Espanha(España)"
                },
                "es",
                "34"
            ],
            [
                {
                    "en": "Sri Lanka (ශ්‍රී ලංකාව)",
                    "es": "Sri Lanka(ශ්‍රී ලංකාව)",
                    "pt": "Sri Lanka(ශ්‍රී ලංකාව)"
                },
                "lk",
                "94"
            ],
            // [
            //     {
            //         "en": "Sudan (‫السودان‬‎)",
            //         "es": "Sudão(‫السودان‬‎)",
            //         "pt": "Sudão(‫السودان‬‎)"
            //     },
            //     "sd",
            //     "249"
            // ],
            [
                {
                    "en": "Suriname",
                    "es": "Surinam",
                    "pt": "Suriname"
                },
                "sr",
                "597"
            ],
            [
                {
                    "en": "Svalbard and Jan Mayen",
                    "es": "Svalbard y Jan Mayen",
                    "pt": "Svalbard e Jan Mayen"
                },
                "sj",
                "47",
                1
            ],
            [
                {
                    "en": "Swaziland",
                    "es": "Suazilandia",
                    "pt": "Suazilândia"
                },
                "sz",
                "268"
            ],
            [
                {
                    "en": "Sweden (Sverige)",
                    "es": "Suecia(Sverige)",
                    "pt": "Suécia(Sverige)"
                },
                "se",
                "46"
            ],
            [
                {
                    "en": "Switzerland (Schweiz)",
                    "es": "Suiza(Schweiz)",
                    "pt": "Suíça(Schweiz)"
                },
                "ch",
                "41"
            ],
            // [
            //     {
            //         "en": "Syria (‫سوريا‬‎)",
            //         "es": "Síria(‫سوريا‬‎)",
            //         "pt": "Síria(‫سوريا‬‎)"
            //     },
            //     "sy",
            //     "963"
            // ],
            [
                {
                    "en": "Taiwan (台灣)",
                    "es": "Taiwan(台灣)",
                    "pt": "Taiwan(台灣)"
                },
                "tw",
                "886"
            ],
            [
                {
                    "en": "Tajikistan",
                    "es": "Tayikistán",
                    "pt": "Tajiquistão"
                },
                "tj",
                "992"
            ],
            [
                {
                    "en": "Tanzania",
                    "es": "Tanzania",
                    "pt": "Tanzânia"
                },
                "tz",
                "255"
            ],
            [
                {
                    "en": "Thailand (ไทย)",
                    "es": "Tailandia(ไทย)",
                    "pt": "Tailândia(ไทย)"
                },
                "th",
                "66"
            ],
            [
                {
                    "en": "Timor-Leste",
                    "es": "Timor-Leste",
                    "pt": "Timor-Leste"
                },
                "tl",
                "670"
            ],
            [
                {
                    "en": "Togo",
                    "es": "Togo",
                    "pt": "Ir"
                },
                "tg",
                "228"
            ],
            [
                {
                    "en": "Tokelau",
                    "es": "Tokelau",
                    "pt": "Tokelau"
                },
                "tk",
                "690"
            ],
            [
                {
                    "en": "Tonga",
                    "es": "Tonga",
                    "pt": "Tonga"
                },
                "to",
                "676"
            ],
            [
                {
                    "en": "Trinidad and Tobago",
                    "es": "Trinidad y Tobago",
                    "pt": "Trindade e Tobago"
                },
                "tt",
                "1868"
            ],
            [
                {
                    "en": "Tunisia (‫تونس‬‎)",
                    "es": "Tunisia(‫تونس‬‎)",
                    "pt": "Tunísia(‫تونس‬‎)"
                },
                "tn",
                "216"
            ],
            [
                {
                    "en": "Turkey (Türkiye)",
                    "es": "Turquía(Türkiye)",
                    "pt": "Peru(Türkiye)"
                },
                "tr",
                "90"
            ],
            [
                {
                    "en": "Turkmenistan",
                    "es": "Turkmenistá",
                    "pt": "Turquemenistão"
                },
                "tm",
                "993"
            ],
            [
                {
                    "en": "Turks and Caicos Islands",
                    "es": "Islas Turcas y Caicos",
                    "pt": "Ilhas Turcas e Caicos"
                },
                "tc",
                "1649"
            ],
            [
                {
                    "en": "Tuvalu",
                    "es": "Tuvalu",
                    "pt": "Tuvalu"
                },
                "tv",
                "688"
            ],
            [
                {
                    "en": "U.S. Virgin Islands",
                    "es": "Islas Virgenes Americanas",
                    "pt": "Ilhas Virgens Americanas"
                },
                "vi",
                "1340"
            ],
            [
                {
                    "en": "Uganda",
                    "es": "Uganda",
                    "pt": "Uganda"
                },
                "ug",
                "256"
            ],
            [
                {
                    "en": "Ukraine (Україна)",
                    "es": "Ucrania(Україна)",
                    "pt": "Ucrânia(Україна)"
                },
                "ua",
                "380"
            ],
            [
                {
                    "en": "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
                    "es": "Emirados Arabes Unidos(‫الإمارات العربية المتحدة‬‎)",
                    "pt": "Emirados Árabes Unidos(‫الإمارات العربية المتحدة‬‎)"
                },
                "ae",
                "971"
            ],
            [
                {
                    "en": "United Kingdom",
                    "es": "Reino Unido",
                    "pt": "Reino Unido"
                },
                "gb",
                "44",
                0
            ],
            [
                {
                    "en": "United States",
                    "es": "Estados Unidos",
                    "pt": "Estados Unidos"
                },
                "us",
                "1",
                0
            ],
            [
                {
                    "en": "Uruguay",
                    "es": "Uruguay",
                    "pt": "Uruguai"
                },
                "uy",
                "598"
            ],
            [
                {
                    "en": "Uzbekistan (Oʻzbekiston)",
                    "es": "Uzbekistan(Oʻzbekiston)",
                    "pt": "Usbequistão(Oʻzbekiston)"
                },
                "uz",
                "998"
            ],
            [
                {
                    "en": "Vanuatu",
                    "es": "Vanuatu",
                    "pt": "Vanuatu"
                },
                "vu",
                "678"
            ],
            [
                {
                    "en": "Vatican City (Città del Vaticano)",
                    "es": "Ciudad del Vaticano(Città del Vaticano)",
                    "pt": "Cidade do Vaticano(Città del Vaticano)"
                },
                "va",
                "39",
                1
            ],
            [
                {
                    "en": "Venezuela",
                    "es": "Venezuela",
                    "pt": "Venezuela"
                },
                "ve",
                "58"
            ],
            [
                {
                    "en": "Vietnam (Việt Nam)",
                    "es": "Vietnam(Việt Nam)",
                    "pt": "Vietnã(Việt Nam)"
                },
                "vn",
                "84"
            ],
            [
                {
                    "en": "Wallis and Futuna (Wallis-et-Futuna)",
                    "es": "Wallis y Futuna(Wallis-et-Futuna)",
                    "pt": "Wallis e Futuna(Wallis-et-Futuna)"
                },
                "wf",
                "681"
            ],
            [
                {
                    "en": "Western Sahara (‫الصحراء الغربية‬‎)",
                    "es": "Sahara Occidental(‫الصحراء الغربية‬‎)",
                    "pt": "Saara Ocidental(‫الصحراء الغربية‬‎)"
                },
                "eh",
                "212",
                1
            ],
            [
                {
                    "en": "Yemen (‫اليمن‬‎)",
                    "es": "Yemen(‫اليمن‬‎)",
                    "pt": "Iémen(‫اليمن‬‎)"
                },
                "ye",
                "967"
            ],
            [
                {
                    "en": "Zambia",
                    "es": "Zambia",
                    "pt": "Zâmbia"
                },
                "zm",
                "260"
            ],
            [
                {
                    "en": "Zimbabwe",
                    "es": "Zimbabwe",
                    "pt": "Zimbábue"
                },
                "zw",
                "263"
            ],
            [
                {
                    "en": "Åland Islands",
                    "es": "Islas Aland",
                    "pt": "Ilhas Åland"
                },
                "ax",
                "358",
                1
            ]
        ], l = 0; l < k.length; l++) {
        var m = k[l];
        k[l] = {
            name: m[0],
            iso2: m[1],
            dialCode: m[2],
            priority: m[3] || 0,
            areaCodes: m[4] || null
        }
    }
});